import React, { Component } from 'react'
import Note from './Note'
import Icon from '../../../util/Icon'

class Notes extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hideNoteTextarea: true,
      hideAddNoteButton: false,
      noteTextareaValue: '',
    }
  }

  handleChange(event) {
    this.setState({noteTextareaValue: event.target.value})
  }

  handleCancel = () => {
    this.setState({hideNoteTextarea: true, hideAddNoteButton: false})
  }

  addNote = event => {
    event.preventDefault()
    this.props.leads.addNote(this.props.leadId, this.state.noteTextareaValue).then(() => {
      this.props.leads.load(this.props.leadId)
    })
    this.setState({noteTextareaValue: '', hideNoteTextarea: true, hideAddNoteButton: false})
  }

  removeNote = (event, noteId) => {
    event.preventDefault()
    this.props.leads.removeNote(this.props.leadId, noteId)
  }

  render() {
    const { leadNotes, users } = this.props

    return (
      <div className='leadNotes'>
        <h1>Notes</h1>
        <button className='miniBadge' hidden={this.state.hideAddNoteButton} onClick={() => this.setState({hideNoteTextarea: false, hideAddNoteButton: true})}>
          <Icon icon="fa-plus-circle" className="fas fa-plus-circle" /> Add
        </button>
        <div className="input" hidden={this.state.hideNoteTextarea}>
          <textarea rows="10" ref={ta => ta && ta.focus()} value={this.state.noteTextareaValue} onChange={this.handleChange.bind(this)} />
          <a href="#" className="button add-button" onClick={this.addNote}>Add</a>
          <button className="cancel" onClick={this.handleCancel}>Cancel</button>
        </div>

        {leadNotes.map(note => (
          <Note
            key={`note-${note.id}`}
            author={users.findById(note.user_id)}
            onDelete={this.removeNote}
            note={note}
          />
        ))}
      </div>
    )
  }
}

export default Notes



// WEBPACK FOOTER //
// client/components/sections/website/Leads/Notes.js